module.exports = __webpack_public_path__ + "static/media/user.e1b4db72.png";